import { Check } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Takeaways = () => {
  const { t } = useLanguage();
  const tk = t.takeaways;

  return (
    <section className="relative py-24 md:py-32 bg-[#01154F]">
      <div className="container-page">
        <Reveal className="max-w-3xl">
          <span className="overline text-[#CEA26B]">{tk.overline}</span>
          <h2 className="mt-4 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
            {tk.title}
          </h2>
          {tk.intro && <p className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed">{tk.intro}</p>}
        </Reveal>

        <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {tk.items.map((item, i) => (
            <Reveal key={i} delay={0.05 * i} className="bg-[#01154F]">
              <li
                data-testid={`takeaway-${i}`}
                className="flex items-start gap-4 p-6 h-full hover:bg-white/[0.03] transition-colors"
              >
                <span className="flex items-center justify-center h-7 w-7 shrink-0 border border-[#CEA26B]/40 bg-[#CEA26B]/10 mt-0.5">
                  <Check className="h-4 w-4 text-[#CEA26B]" />
                </span>
                <span className="text-base text-slate-200 leading-relaxed">{item}</span>
              </li>
            </Reveal>
          ))}
        </ul>

        <Reveal delay={0.1}>
          <p
            data-testid="takeaways-closing"
            className="mt-10 text-base md:text-lg text-slate-300 leading-relaxed max-w-3xl border-l-2 border-[#CEA26B] pl-6"
          >
            {tk.closing}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
